"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/iot_vehicle/iot_frontend/iot_supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _merchant = require("@/api/merchant");
var _index = require("@/api/ads/index.js");
var _customPage = _interopRequireDefault(require("@/components/customPage"));
var _editDialog = _interopRequireDefault(require("./dialog/editDialog"));
var _sendCoupon = _interopRequireDefault(require("./dialog/sendCoupon"));
var _default = {
  components: {
    customPage: _customPage.default,
    editDialog: _editDialog.default,
    sendCoupon: _sendCoupon.default
  },
  data: function data() {
    return {
      loading: true,
      searchForm: {
        merchant_id: '',
        name: ''
      },
      total: 0,
      tableData: [],
      editItem: null,
      merchantList: []
    };
  },
  mounted: function mounted() {
    if (this.sMerchantId == 0) {
      this.getMerchantList();
    }
    this.getList();
  },
  methods: {
    getMerchantList: function () {
      var _getMerchantList2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        var res;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _merchant.getMerchantList)({
                  status: 1
                });
              case 2:
                res = _context.sent;
                if (res.data) {
                  this.merchantList = res.data;
                }
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function getMerchantList() {
        return _getMerchantList2.apply(this, arguments);
      }
      return getMerchantList;
    }(),
    getList: function getList(flag) {
      var _this = this;
      // flag为true, 则不刷新表格
      var _this$$refs$customPag = this.$refs.customPage,
        page = _this$$refs$customPag.page,
        pageSize = _this$$refs$customPag.pageSize;
      if (!flag) {
        this.tableData = [];
      }
      this.loading = true;
      (0, _index.getAdUserList)((0, _objectSpread2.default)({
        page: page,
        pageSize: pageSize
      }, this.searchForm)).then(function (res) {
        _this.loading = false;
        _this.tableData = res.data || [];
        _this.total = res.total;
      });
    },
    // 发券
    openSendCoupon: function openSendCoupon(val) {
      this.editItem = val || null;
      this.$refs.sendCoupon.dialogVisible = true;
    },
    // 编辑
    openEditDialog: function openEditDialog(val) {
      this.editItem = val || null;
      this.$refs.editDialog.dialogVisible = true;
    },
    // 删除
    removeItem: function removeItem(item) {
      var _this2 = this;
      this.$confirm('您确定要删除吗?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        (0, _index.delUser)({
          id: item.id
        }).then(function (res) {
          _this2.getList(true);
        });
      }).catch(function () {});
    },
    // 批量操作
    handleCommand: function handleCommand(command) {},
    // 查询
    search: function search() {
      this.$refs.customPage.page = 1;
      this.getList();
    },
    // 重置
    reset: function reset() {
      this.searchForm = this.$options.data().searchForm;
      this.getList();
    }
  }
};
exports.default = _default;